// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Value = any;

type PropertyName = string | number | symbol;

export type Customizer = (
    aValue: Value,
    bValue: Value,
    key: PropertyName | undefined,
    path: PropertyName[]
) => boolean | undefined;

const isDeepEqualWithInner = (
    aValue: Value,
    bValue: Value,
    key: PropertyName | undefined,
    path: PropertyName[],
    customizer: Customizer | undefined
) => {
    const customizerOutput = typeof customizer === 'function' ? customizer(aValue, bValue, key, path) : undefined;
    if (typeof customizerOutput === 'boolean') {
        return customizerOutput;
    }

    if (aValue === bValue) {
        return true;
    }

    if (Array.isArray(aValue) && Array.isArray(bValue)) {
        if (aValue.length !== bValue.length) {
            return false;
        }

        for (let key = 0; key < aValue.length; key++) {
            const isEqual = isDeepEqualWithInner(aValue[key], bValue[key], key, path.concat(key), customizer);
            if (!isEqual) {
                return false;
            }
        }

        return true;
    }

    if (typeof aValue === 'object' && aValue !== null && typeof bValue === 'object' && bValue !== null) {
        const keys = new Set([
            ...Object.getOwnPropertyNames(aValue),
            ...Object.getOwnPropertySymbols(aValue),
            ...Object.getOwnPropertyNames(bValue),
            ...Object.getOwnPropertySymbols(bValue)
        ]);
        for (const key of keys) {
            const isEqual = isDeepEqualWithInner(aValue[key], bValue[key], key, path.concat(key), customizer);
            if (!isEqual) {
                return false;
            }
        }

        return true;
    }

    return aValue === bValue;
};

/**
 * @param aValue
 * @param bValue
 * @param customizer
 * @returns
 */
const isDeepEqualWith = (aValue: Value, bValue: Value, customizer?: Customizer) =>
    isDeepEqualWithInner(aValue, bValue, undefined, [], customizer);

export default isDeepEqualWith;
